import { Handle } from '@xyflow/react';
import CustomNode from './CustomNode';

const SingleTargetNode = ({ data, isConnectable }) => {
 
  const moduleDetails = data.label.props.details;

  return (
    <div>
      {moduleDetails.targetPosition !== "" ?
        <Handle
          type="target"
          position={moduleDetails.targetPosition}
          isConnectable={isConnectable}
          id="b"
        />
      :""}
        <CustomNode details={moduleDetails}/>
      {moduleDetails.sourcePosition !== "" ?
        <Handle
          type="source"
          position={moduleDetails.sourcePosition}
          id="a"
          isConnectable={isConnectable}
        />
      :""}
    </div>
  );
};

export default SingleTargetNode;
